<template>
  <span>
    <media-content></media-content>
    <v-btn
        class='margin'
        absolute
        fixed
        fab
        bottom
        right
        @click="$vuetify.goTo('#start')">
        <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </span>
</template>

<script>
import MediaContent from "@/components/Media/MediaContent";
export default {
  name: "Media",
  components: {
    MediaContent
  }
};
</script>

<style scoped>
.margin{
    margin-bottom: 4rem !important;
}

.url{
  text-decoration-line: none;
  color: red;
}
</style>